"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Modal = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));
var _noScroll = _interopRequireDefault(require("no-scroll"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _modalHeader = _interopRequireDefault(require("./modal-header"));
var _styledModal = require("./styled-modal");
var _excluded = ["children", "title", "backCallback", "className", "closeCallback", "dataAnalyticsId", "dataTestId", "focusTrapOptions", "hasBackButton", "hasPadding", "headerIcon", "hasClose", "onClose", "open", "srLabelBackButton", "srLabelCloseButton", "zIndex", "linkCenterAlignment", "linkCenterStacked", "link", "buttonLink"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef,
  useCallback = _react["default"].useCallback,
  useEffect = _react["default"].useEffect,
  useMemo = _react["default"].useMemo,
  useRef = _react["default"].useRef,
  useState = _react["default"].useState;
var displayName = 'Modal';
var propTypes = {
  children: _propTypes["default"].node.isRequired,
  title: _propTypes["default"].string.isRequired,
  backCallback: _propTypes["default"].func,
  className: _propTypes["default"].string,
  closeCallback: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string,
  dataAnalyticsId: _propTypes["default"].string,
  focusTrapOptions: _propTypes["default"].object,
  hasBackButton: _propTypes["default"].bool,
  hasPadding: _propTypes["default"].bool,
  headerIcon: _propTypes["default"].element,
  hasClose: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  open: _propTypes["default"].bool,
  srLabelBackButton: _propTypes["default"].string,
  srLabelCloseButton: _propTypes["default"].string,
  zIndex: _propTypes["default"].string,
  linkCenterAlignment: _propTypes["default"].bool,
  linkCenterStacked: _propTypes["default"].bool,
  link: _propTypes["default"].shape({
    text: _propTypes["default"].string.isRequired,
    href: _propTypes["default"].string.isRequired,
    onClick: _propTypes["default"].func
  }),
  buttonLink: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    variant: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary']).isRequired,
    text: _propTypes["default"].string.isRequired,
    href: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  }))
};
var defaultProps = {
  backCallback: function backCallback() {},
  className: undefined,
  closeCallback: function closeCallback() {},
  dataAnalyticsId: undefined,
  dataTestId: null,
  focusTrapOptions: {},
  hasBackButton: false,
  hasPadding: true,
  headerIcon: undefined,
  hasClose: true,
  onClose: function onClose() {},
  open: false,
  srLabelBackButton: undefined,
  srLabelCloseButton: undefined,
  zIndex: undefined,
  linkCenterAlignment: false,
  linkCenterStacked: false,
  link: {
    type: 'link',
    href: undefined,
    text: undefined
  },
  buttonLink: []
};
var Modal = exports.Modal = forwardRef(function (_ref, ref) {
  var children = _ref.children,
    title = _ref.title,
    _backCallback = _ref.backCallback,
    className = _ref.className,
    _closeCallback = _ref.closeCallback,
    dataAnalyticsId = _ref.dataAnalyticsId,
    dataTestId = _ref.dataTestId,
    focusTrapOptions = _ref.focusTrapOptions,
    hasBackButton = _ref.hasBackButton,
    hasPadding = _ref.hasPadding,
    headerIcon = _ref.headerIcon,
    hasClose = _ref.hasClose,
    onClose = _ref.onClose,
    open = _ref.open,
    srLabelBackButton = _ref.srLabelBackButton,
    srLabelCloseButton = _ref.srLabelCloseButton,
    zIndex = _ref.zIndex,
    linkCenterAlignment = _ref.linkCenterAlignment,
    linkCenterStacked = _ref.linkCenterStacked,
    link = _ref.link,
    buttonLink = _ref.buttonLink,
    rest = _objectWithoutProperties(_ref, _excluded);
  // Refs
  var overlayRef = useRef();
  var gridContainerRef = useRef();
  var gridRowRef = useRef();

  // States
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    activeTrap = _useState2[0],
    setActiveTrap = _useState2[1];
  // Unique IDs
  var modalHeadingId = useMemo(function () {
    return (0, _fuseUtils.namedUuid)('modal-header-heading');
  }, []);

  // Event handlers
  // Run onClose when Overlay is clicked
  var handleOverlayOnClick = useCallback(function (event) {
    if (event.target !== overlayRef.current && event.target !== gridContainerRef.current && event.target !== gridRowRef.current) return;
    onClose();
    _closeCallback(event, ref);
  }, []);
  // Run onClose when keypress is escape, otherwise do nothing
  var handleKeyPress = useCallback(function (event) {
    if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
      onClose();
      _closeCallback(event, ref);
    }
  }, []);

  // Set noScroll and activeTrap only when modal opens and cleanup on close
  useEffect(function () {
    if (open) {
      _noScroll["default"].on();
      // Focus trap to be activated after 0.2s due to modal transition time when open
      setTimeout(function () {
        setActiveTrap(true);
      }, 200);
    } else {
      _noScroll["default"].off();
      setActiveTrap(false);
    }
    return function cleanup() {
      if (!open) {
        _noScroll["default"].off();
        setActiveTrap(false);
      }
    };
  }, [open]);

  // Add key press event listener to window only on initial load
  useEffect(function () {
    var mobileBreakpoint = (0, _fuseUtils.remToPixel)(_grid.gridConfig.m.maxWidth);
    var isMobileTabletViewPort = window.innerWidth <= mobileBreakpoint;

    // Add event keyup event listener
    window.addEventListener('keyup', handleKeyPress);
    // Sets the css variable --vh to root element instead of using traditional css vh to mitigate mobile / tablet top and bottom bar issue
    if (isMobileTabletViewPort) (0, _fuseUtils.setCSSVarViewHeight)();
    return function cleanup() {
      // Clean up and remove keyup event listener
      window.removeEventListener('keyup', handleKeyPress);
    };
  }, []);
  var items = link ? [link].concat(_toConsumableArray(buttonLink.slice(0, 2))) : _toConsumableArray(buttonLink.slice(0, 2));
  return /*#__PURE__*/_react["default"].createElement(_styledModal.StyledModal, _extends({
    className: open ? "fuse-modal--show ".concat(className !== null && className !== void 0 ? className : "") : className !== null && className !== void 0 ? className : "",
    "data-testid": dataTestId || 'fuse-modal',
    open: open,
    ref: ref,
    zIndex: zIndex
  }, rest), /*#__PURE__*/_react["default"].createElement(_styledModal.StyledModalOverlay, {
    onClick: handleOverlayOnClick,
    ref: overlayRef
  }, /*#__PURE__*/_react["default"].createElement(_styledModal.StyledModalGridContainer, {
    ref: gridContainerRef
  }, /*#__PURE__*/_react["default"].createElement(_styledModal.StyledModalGridRow, {
    ref: gridRowRef
  }, /*#__PURE__*/_react["default"].createElement(_styledModal.StyledModalGridItem, {
    xxs: "12",
    m: "10",
    l: "6",
    "colStart-xxs": "1",
    "colStart-m": "2",
    "colStart-l": "4"
  }, /*#__PURE__*/_react["default"].createElement(_focusTrapReact["default"], {
    active: activeTrap,
    focusTrapOptions: _objectSpread({
      allowOutsideClick: true,
      clickOutsideDeactivates: true,
      initialFocus: '.fuse-modal__content'
    }, focusTrapOptions)
  }, /*#__PURE__*/_react["default"].createElement(_styledModal.StyledModalContainer, {
    "aria-modal": open ? 'true' : undefined,
    "aria-labelledby": modalHeadingId,
    role: "dialog",
    tabIndex: "-1"
  }, /*#__PURE__*/_react["default"].createElement(_modalHeader["default"], {
    title: title,
    backCallback: function backCallback(event) {
      _backCallback(event, ref);
    },
    closeCallback: function closeCallback(event) {
      _closeCallback(event, ref);
      onClose();
    },
    hasBackButton: hasBackButton,
    hasClose: hasClose,
    headerIcon: headerIcon,
    headingId: modalHeadingId,
    srLabelBackButton: srLabelBackButton,
    srLabelCloseButton: srLabelCloseButton
  }), /*#__PURE__*/_react["default"].createElement(_styledModal.StyledModalBody, {
    hasPadding: hasPadding
  }, children), /*#__PURE__*/_react["default"].createElement(_styledModal.StyledModalFooter, _extends({
    className: className,
    "data-testid": dataTestId,
    hasPadding: hasPadding,
    linkCenterStacked: linkCenterStacked,
    linkCenterAlignment: linkCenterAlignment
  }, rest), /*#__PURE__*/_react["default"].createElement(_styledModal.StyledModalLinkContainer, {
    linkCenterStacked: linkCenterStacked,
    linkCenterAlignment: linkCenterAlignment
  }, items.map(function (item, index) {
    var key = "".concat(item.text, "-").concat(index);
    if (item.variant) {
      return /*#__PURE__*/_react["default"].createElement(_styledModal.StyledModalButton, {
        key: "button-".concat(key),
        className: "fuse-button-group__".concat(item.variant),
        href: item.href,
        variant: item.variant,
        onClick: item.onClick,
        linkCenterStacked: linkCenterStacked
      }, item.text);
    }
    return /*#__PURE__*/_react["default"].createElement(_styledModal.StyledModalLink, {
      key: "link-".concat(key),
      href: item.href,
      linkCenterStacked: linkCenterStacked
    }, item.text);
  }))))))))));
});
Modal.displayName = displayName;
Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
var _default = exports["default"] = Modal;